<template>
  <div></div>
</template>

<script>
import api from "@/api";
export default {
  components: {},
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style lang="scss" scoped></style>
